// src/components/mechanicadmin/topnavbar/MechanicTopNavbar.jsx

import React, { useState, useRef, useEffect } from "react";
import {
  FiMenu,
  FiSearch,
  FiChevronDown,
  FiUser,
  FiX,
} from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import "../../../assets/css/mechanic/mechanictopnavbar/MechanicTopBar.css";

const MechanicTopNavbar = ({ onToggleSidebar, isSidebarOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const dropdownRef = useRef(null);

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes("/dashboard")) return "Dashboard";
    if (path.includes("/profile")) return "My Profile";
    if (path.includes("/requests")) return "Maintenance Requests";
    if (path.includes("/kyc")) return "KYC";
    if (path.includes("/completed")) return "Completed Jobs";
    if (path.includes("/messages")) return "Messages";
    if (path.includes("/earnings")) return "Earnings";
    if (path.includes("/reviews")) return "Reviews & Ratings";
    if (path.includes("/dispute")) return "Dispute";
    if (path.includes("/notification")) return "Notifications";
    return "Dashboard";
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/mechanic-admin/search?q=${searchQuery}`);
    }
  };

  return (
    <nav className="mechanic-admin-topnavbar">
      <div className="mechanic-topnavbar-left">
        {/* Hamburger */}
        <button
          className="mechanic-hamburger-btn"
          onClick={onToggleSidebar}
          aria-label="Toggle Sidebar"
        >
          {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>

        {/* Page Title */}
        <h1 className="mechanic-page-title">{getPageTitle()}</h1>
      </div>

      <div className="mechanic-topnavbar-right">
        {/* Search */}
        <form className="mechanic-search-container" onSubmit={handleSearch}>
          <FiSearch className="mechanic-search-icon" />
          <input
            type="text"
            className="mechanic-search-input"
            placeholder="Search jobs, requests..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </form>

        {/* Profile Dropdown */}
        <div className="mechanic-admin-profile-container" ref={dropdownRef}>
          <button
            className="mechanic-admin-profile-btn"
            onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            aria-label="Mechanic Menu"
          >
            <div className="mechanic-admin-avatar">M</div>
            <span className="mechanic-admin-name">Mechanic Panel</span>
            <FiChevronDown
              className={`mechanic-chevron-icon ${
                isDropdownOpen ? "rotate" : ""
              }`}
              size={18}
            />
          </button>

          {isDropdownOpen && (
            <div className="mechanic-admin-dropdown">
              <div className="mechanic-dropdown-header">
                <div className="mechanic-dropdown-avatar">M</div>
                <div className="mechanic-dropdown-info">
                  <h4 className="mechanic-dropdown-name">Mechanic Panel</h4>
                  <p className="mechanic-dropdown-email">
                    mechanic@agrirent.com
                  </p>
                </div>
              </div>

              <div className="mechanic-dropdown-divider"></div>

              <button
                className="mechanic-dropdown-item"
                onClick={() => {
                  navigate("/mechanic-admin/profile");
                  setIsDropdownOpen(false);
                }}
              >
                <FiUser size={18} />
                <span>Profile</span>
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default MechanicTopNavbar;